import React, { Component } from 'react'
import DatePicker from 'react-datepicker'
import moment from 'moment'

class FormDatePicker extends Component {
  constructor () {
    super()

    this.state = {
      startDate: moment()
    }
    this.handleChange = this.handleChange.bind(this)
  }
  handleChange (date) {
    this.setState({
      startDate: date
    })
  }
  render () {
    const { input, label, direction, loading, meta: { touched, error } } = this.props
    if (direction === 'vertical') {
      return (
        <div className={(touched && error) ? 'has-error' : ''}>
          <label className='control-label'>{label}</label>
          <DatePicker
            {...input}
            className='form-control'
            dateFormat='DD/MM/YYYY'
            selected={input.value ? moment(input.value, 'DD-MM-YYYY') : null}
            disabled={loading}
          />
          {touched && (error && <span className='help-block'>{error}</span>)}
        </div>
      )
    } else {
      return (
        <div className={(touched && error) ? 'has-error' : ''}>
          <label className='col-sm-2 control-label'>{label}</label>
          <div className='col-sm-9'>
            <DatePicker
              {...input}
              className='form-control'
              dateFormat='DD/MM/YYYY'
              selected={input.value ? moment(input.value, 'DD-MM-YYYY') : null}
              disabled={loading}
            />
            {touched && (error && <span className='help-block'>{error}</span>)}
          </div>
        </div>
      )
    }
  }
}

export default FormDatePicker



// WEBPACK FOOTER //
// ./src/components/FormDatePicker.js